import type * as Types from 'web-app/react/test-child-actions/types';
import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'MODALS/TEST_CHILD_MODAL';

export const {action: showTestChildActionsModal} = createAction(
    `${domain}/SHOW`,
    (payload: Types.TestChildActionsModalPayload) => payload,
);

export const {action: hideTestChildActionsModal} = createAction(`${domain}/HIDE`, () => ({}));
